import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { LayerApi } from '../../../api/layer-api';
import { UserApi } from '../../../api/user-api';
import { InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var UnshareLayerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UnshareLayerComponent, _super);
    function UnshareLayerComponent(_vcr, layerApi, userApi, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerApi = layerApi;
        _this.userApi = userApi;
        _this.cdr = cdr;
        _this.loading = false;
        _this.unshared = [];
        _this.unsharedIds = [];
        _this.shared = [];
        _this.onclose = new EventEmitter();
        _this.unsharingLayer = false;
        _this.successMessage = false;
        _this.failureMessage = false;
        _this.layerTitle = '';
        _this.registerEvent('onclose', _this.onclose);
        return _this;
    }
    Object.defineProperty(UnshareLayerComponent.prototype, "layerId", {
        get: function () { return this._layerId; },
        set: function (value) {
            this._layerId = value;
            if (this._layerId) {
                this.updateData();
            }
        },
        enumerable: true,
        configurable: true
    });
    UnshareLayerComponent.prototype.updateData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, layers, userIds, _b, _c, userLayer, _d, _e;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.getLayers()];
                    case 1:
                        layers = _f.sent();
                        this.layerTitle = layers[0].name;
                        userIds = [];
                        try {
                            for (_b = tslib_1.__values(layers[0].userLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                userLayer = _c.value;
                                if (userLayer.accessLevel !== 'OWNER') {
                                    userIds.push(userLayer.userId);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _d = this;
                        if (!(userIds.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getUsers(userIds)];
                    case 2:
                        _e = _f.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _e = [];
                        _f.label = 4;
                    case 4:
                        _d.shared = _e;
                        this.loading = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    UnshareLayerComponent.prototype.getLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.getLayers([this.layerId], 'name, userLayers{accessLevel, userId}')];
            });
        });
    };
    UnshareLayerComponent.prototype.getUsers = function (userIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userApi.getUsers(userIds)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UnshareLayerComponent.prototype.unshare = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.unshareLayer(this.unsharedIds, this.layerId)];
            });
        });
    };
    UnshareLayerComponent.prototype.unshareUser = function (index) {
        this.unshared.push(this.shared[index]);
        this.unsharedIds.push(this.shared[index].id);
        this.shared.splice(index, 1);
    };
    UnshareLayerComponent.prototype.undoUnshare = function (index) {
        this.shared.push(this.unshared[index]);
        this.unshared.splice(index, 1);
        this.unsharedIds.splice(index, 1);
    };
    UnshareLayerComponent.prototype.unshareLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var milliseconds, result, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        milliseconds = 3000;
                        this.unsharingLayer = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.unshare()];
                    case 2:
                        result = _a.sent();
                        if (result) {
                            this.unsharingLayer = false;
                            this.successMessage = true;
                            this.resetAndClose();
                            setTimeout(function () {
                                _this.successMessage = false;
                            }, milliseconds);
                        }
                        else {
                            this.unsharingLayer = false;
                            this.failureMessage = true;
                            setTimeout(function () {
                                _this.failureMessage = false;
                            }, milliseconds);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.unsharingLayer = false;
                        this.failureMessage = true;
                        setTimeout(function () {
                            _this.failureMessage = false;
                        }, milliseconds);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UnshareLayerComponent.prototype.resetAndClose = function () {
        this.shared = [];
        this.unshared = [];
        this.unsharedIds = [];
        this.onclose.emit();
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Number])
    ], UnshareLayerComponent.prototype, "layerId", null);
    return UnshareLayerComponent;
}(BaseComponent));
export { UnshareLayerComponent };
